function Done({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg  width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.9999 11.1996L1.7999 6.99961L0.399902 8.39961L5.9999 13.9996L17.9999 1.99961L16.5999 0.599609L5.9999 11.1996Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default Done;
